module.exports = __webpack_public_path__ + "img/28.29c1b00a.jpg";